import Table from "../Table";
import "./Container.css"

const Container = () => {

    return(
        <section id="estatistica">
            <article className="container_estatic">
                <h1>Estatistícas</h1>

                <Table />
            </article>

        </section>
    )
}
export default Container;